/*

Derived from https://backstage.io/storybook/?path=/story/plugins-home-templates--default-template
Docs: https://backstage.io/docs/getting-started/homepage

*/

import {
    HomePageToolkit,
    HomePageCompanyLogo,
} from '@backstage/plugin-home';
import { Content, Page, InfoCard, Link } from '@backstage/core-components';
import { Grid, makeStyles } from '@material-ui/core';
import LogoFull from '../Root/LogoFull';


const useLogoStyles = makeStyles(theme => ({
    container: {
        margin: theme.spacing(5, 0),
    },
}));

const grafanaStyles = makeStyles({
    svg: {
        width: 'auto',
        height: 28,
    },
    path: {
        fill: '#7df3e1',
    },
});

const ToolkitGrafanaLogoIcon = () => {
    const classes = grafanaStyles();

    return (
        <svg className={classes.svg} viewBox="8.5 1 334.1000000000001 363" xmlns="http://www.w3.org/2000/svg"><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="175.5" x2="175.5" y1="30%" y2="99%"><stop offset="0" stopColor="#f05a28" /><stop offset="1" stopColor="#fbca0a" /></linearGradient><path d="M342 161.2c-.6-6.1-1.6-13.1-3.6-20.9-2-7.7-5-16.2-9.4-25s-10.1-17.9-17.5-26.8c-2.9-3.5-6.1-6.9-9.5-10.2 5.1-20.3-6.2-37.9-6.2-37.9-19.5-1.2-31.9 6.1-36.5 9.4-.8-.3-1.5-.7-2.3-1-3.3-1.3-6.7-2.6-10.3-3.7-3.5-1.1-7.1-2.1-10.8-3s-7.4-1.6-11.2-2.2c-.7-.1-1.3-.2-2-.3C214.2 12.4 189.8 1 189.8 1c-27.3 17.3-32.4 41.5-32.4 41.5s-.1.5-.3 1.4c-1.5.4-3 .9-4.5 1.3-2.1.6-4.2 1.4-6.2 2.2-2.1.8-4.1 1.6-6.2 2.5-4.1 1.8-8.2 3.8-12.2 6-3.9 2.2-7.7 4.6-11.4 7.1l-1-.4c-37.8-14.4-71.3 2.9-71.3 2.9-3.1 40.2 15.1 65.5 18.7 70.1-.9 2.5-1.7 5-2.5 7.5-2.8 9.1-4.9 18.4-6.2 28.1-.2 1.4-.4 2.8-.5 4.2C18.8 192.7 8.5 228 8.5 228c29.1 33.5 63.1 35.6 63.1 35.6l.1-.1c4.3 7.7 9.3 15 14.9 21.9 2.4 2.9 4.8 5.6 7.4 8.3-10.6 30.4 1.5 55.6 1.5 55.6 32.4 1.2 53.7-14.2 58.2-17.7 3.2 1.1 6.5 2.1 9.8 2.9 10 2.6 20.2 4.1 30.4 4.5 2.5.1 5.1.2 7.6.1h3.6l1.6-.1v.1c15.3 21.8 42.1 24.9 42.1 24.9 19.1-20.1 20.2-40.1 20.2-44.4v-.3-.6-.9c4-2.8 7.8-5.8 11.4-9.1 7.6-6.9 14.3-14.8 19.9-23.3l1.5-2.4c21.6 1.2 36.9-13.4 36.9-13.4-3.6-22.5-16.4-33.5-19.1-35.6s-.1-.1-.3-.2-.2-.2-.2-.2c-.1-.1-.3-.2-.5-.3.1-1.4.2-2.7.3-4.1.2-2.4.2-4.9.2-7.3v-3.2-.6l-.1-1.5-.1-2c0-.7-.1-1.3-.2-1.9s-.1-1.3-.2-1.9l-.2-1.9-.3-1.9c-.4-2.5-.8-4.9-1.4-7.4-2.3-9.7-6.1-18.9-11-27.2-5-8.3-11.2-15.6-18.3-21.8-7-6.2-14.9-11.2-23.1-14.9-8.3-3.7-16.9-6.1-25.5-7.2-4.3-.6-8.6-.8-12.9-.7h-3.2l-1.6.1c-.6 0-1.2.1-1.7.1-2.2.2-4.4.5-6.5.9-8.6 1.6-16.7 4.7-23.8 9s-13.3 9.6-18.3 15.6-8.9 12.7-11.6 19.6-4.2 14.1-4.6 21c-.1 1.7-.1 3.5-.1 5.2v1.3l.1 1.4c.1.8.1 1.7.2 2.5.3 3.5 1 6.9 1.9 10.1 1.9 6.5 4.9 12.4 8.6 17.4s8.2 9.1 12.9 12.4c4.7 3.2 9.8 5.5 14.8 7s10 2.1 14.7 2.1h2.6c.3 0 .6 0 .9-.1.5 0 1-.1 1.5-.1.1 0 .3 0 .4-.1l.5-.1c.3 0 .6-.1.9-.1.6-.1 1.1-.2 1.7-.3s1.1-.2 1.6-.4c1.1-.2 2.1-.6 3.1-.9 2-.7 4-1.5 5.7-2.4 1.8-.9 3.4-2 5-3 .4-.3.9-.6 1.3-1 1.6-1.3 1.9-3.7.6-5.3-1.1-1.4-3.1-1.8-4.7-.9l-1.2.6c-1.4.7-2.8 1.3-4.3 1.8s-3.1.9-4.7 1.2c-.8.1-1.6.2-2.5.3-.4 0-.8.1-1.3.1h-2.4c-.5 0-1 0-1.5-.1H210.2c-.2 0-.5 0-.7-.1-.5-.1-.9-.1-1.4-.2-3.7-.5-7.4-1.6-10.9-3.2-3.6-1.6-7-3.8-10.1-6.6s-5.8-6.1-7.9-9.9-3.6-8-4.3-12.4c-.3-2.2-.5-4.5-.4-6.7 0-.6.1-1.2.1-1.8v-.8c0-.3.1-.6.1-.9.1-1.2.3-2.4.5-3.6 1.7-9.6 6.5-19 13.9-26.1 1.9-1.8 3.9-3.4 6-4.9s4.4-2.8 6.8-3.9 4.8-2 7.4-2.7c2.5-.7 5.1-1.1 7.8-1.4 1.3-.1 2.6-.2 4-.2h3.1l1.1.1c2.9.2 5.7.6 8.5 1.3 5.6 1.2 11.1 3.3 16.2 6.1 10.2 5.7 18.9 14.5 24.2 25.1 2.7 5.3 4.6 11 5.5 16.9.2 1.5.4 3 .5 4.5l.1 1.1.1 1.1V217.8c0 .7-.1 1.9-.1 2.6-.1 1.6-.3 3.3-.5 4.9s-.5 3.2-.8 4.8-.7 3.2-1.1 4.7c-.8 3.1-1.8 6.2-3 9.3-2.4 6-5.6 11.8-9.4 17.1-7.7 10.6-18.2 19.2-30.2 24.7-6 2.7-12.3 4.7-18.8 5.7-3.2.6-6.5.9-9.8 1h-5c-1.8 0-3.5-.1-5.3-.3-7-.5-13.9-1.8-20.7-3.7-6.7-1.9-13.2-4.6-19.4-7.8-12.3-6.6-23.4-15.6-32-26.5-4.3-5.4-8.1-11.3-11.2-17.4s-5.6-12.6-7.4-19.1c-1.8-6.6-2.9-13.3-3.4-20.1l-.1-1.3v-5.7-.7-2.5c.1-3.3.4-6.8.8-10.2s1-6.9 1.7-10.3 1.5-6.8 2.5-10.2c1.9-6.7 4.3-13.2 7.1-19.3 5.7-12.2 13.1-23.1 22-31.8 2.2-2.2 4.5-4.2 6.9-6.2 2.4-1.9 4.9-3.7 7.5-5.4 2.5-1.7 5.2-3.2 7.9-4.6 1.3-.7 2.7-1.4 4.1-2l2.1-.9 2.1-.9c2.8-1.2 5.7-2.2 8.7-3.1.7-.2 1.5-.4 2.2-.7.7-.2 1.5-.4 2.2-.6 1.5-.4 3-.8 4.5-1.1.7-.2 1.5-.3 2.3-.5s1.5-.3 2.3-.5c.8-.1 1.5-.3 2.3-.4l1.1-.2 1.2-.2c.8-.1 1.5-.2 2.3-.3.9-.1 1.7-.2 2.6-.3.7-.1 1.9-.2 2.6-.3.5-.1 1.1-.1 1.6-.2l1.1-.1.5-.1h.6c.9-.1 1.7-.1 2.6-.2l1.3-.1h1c.7 0 1.5-.1 2.2-.1 2.9-.1 5.9-.1 8.8 0 5.8.2 11.5.9 17 1.9 11.1 2.1 21.5 5.6 31 10.3 9.5 4.6 17.9 10.3 25.3 16.5.5.4.9.8 1.4 1.2.4.4.9.8 1.3 1.2.9.8 1.7 1.6 2.6 2.4s1.7 1.6 2.5 2.4 1.6 1.6 2.4 2.5c3.1 3.3 6 6.6 8.6 10 5.2 6.7 9.4 13.5 12.7 19.9l.6 1.2.6 1.2c.4.8.8 1.6 1.1 2.4.4.8.7 1.5 1.1 2.3.3.8.7 1.5 1 2.3 1.2 3 2.4 5.9 3.3 8.6 1.5 4.4 2.6 8.3 3.5 11.7.3 1.4 1.6 2.3 3 2.1 1.5-.1 2.6-1.3 2.6-2.8.1-3.6 0-7.9-.5-12.8z" fill="url(#a)" /></svg>
    );
};

const buildkiteStyles = makeStyles({
    svg: {
        width: 'auto',
        height: 28,
        fill: 'rgb(255,0,207)',
    },
});

const ToolkitBuildkiteLogoIcon = () => {
    const classes = buildkiteStyles();

    return (
        <svg className={classes.svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 334"><path fill="#30f2a2" d="M0 0v166.6L166.7 250V83.3L0 0zM333.3 0v166.6L500 83.3 333.3 0z" /><path fill="#14cc80" d="M333.3 166.7v166.6L500 250V83.3l-166.7 83.4z" /><path fill="#14cc80" d="M166.7 83.3V250l166.7-83.3V0L166.7 83.3z" /></svg>
    );
};

const hugoStyles = makeStyles({
    svg: {
        width: 'auto',
        height: 40,
        fill: 'rgb(255,0,207)',
    },
});

const HugoLogoIcon = () => {
    const classes = hugoStyles();

    return (
        <svg className={classes.svg} viewBox="0 0 128 128">
        <path fill="#FF4088" d="M71.2 8.5l36.7 21.3c4.3 2.5 7 7.2 7 12.2v43.7c0 5.6-3 10.7-7.8 13.4l-36.4 20.5c-4.8 2.7-10.7 2.7-15.5-.1l-33.5-19.3c-5.3-3-8.5-8.6-8.5-14.7V44.1c0-6.1 3.2-11.8 8.4-15L54.4 8.8c5.1-3.2 11.6-3.3 16.8-.3z" /><path fill="#C9177E" d="M63 126c-3.5 0-6.9-.9-10-2.7L19.5 104c-6.6-3.8-10.7-10.9-10.7-18.5V44.1c0-7.7 3.9-14.6 10.4-18.7L52.1 5.1c6.5-4 14.6-4.1 21.2-.3L110 26.1c5.7 3.3 9.2 9.4 9.2 15.9v43.7c0 7.1-3.8 13.7-10 17.2l-36.4 20.5c-3 1.7-6.4 2.6-9.8 2.6zm0-115.3c-2.2 0-4.4.6-6.3 1.8l-33 20.3c-4 2.4-6.3 6.7-6.3 11.3v41.5c0 4.5 2.4 8.7 6.3 11l33.5 19.3c3.5 2 7.8 2 11.3.1l36.4-20.5c3.5-2 5.6-5.6 5.6-9.6V42.1c0-3.5-1.9-6.7-4.9-8.5L69 12.3c-1.8-1.1-3.9-1.6-6-1.6z" /><path fill="#FFF" d="M38.6 96.9V30.5h13.9v24.2h23V30.5h13.9v66.4H75.5v-29h-23v29z" />
        </svg>
    );
};

export const Homepage = () => {
    const { container } = useLogoStyles();

    return (
        <Page themeId="home">
            <Content>
                <Grid container justifyContent="center" spacing={6}>
                    <HomePageCompanyLogo
                        className={container}
                        logo={<LogoFull />}
                    />
                    <Grid container item xs={12}>
                        <Grid item xs={12} md={6}>
                            <InfoCard title="Welcome">
                                {/* placeholder for content */}
                                <div>
                                    <h3>Welcome to gridX's Backstage instance!</h3>
                                    <p>On this portal, you'll find anything around the development department.<br /> What do we have planned:</p>
                                    <ul>
                                        <li>Adding Software Templates (Boilerplate projects)</li>
                                        <li>Add documentation and team handbooks</li>
                                        <li>Tell us your ideas on <Link to='https://grid-x.slack.com/archives/C056HMCGQ5U'>#21-team-sre</Link></li>
                                    </ul>
                                </div>
                            </InfoCard>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <HomePageToolkit
                                title='Important Tools'
                                tools={[{
                                    url: 'https://oculus.sre.gridx.de',
                                    label: 'Grafana',
                                    icon: <ToolkitGrafanaLogoIcon />,
                                },
                                {
                                    url: 'https://buildkite.com/gridX/',
                                    label: 'Buildkite',
                                    icon: <ToolkitBuildkiteLogoIcon />,
                                },
                                {
                                    url: 'https://engineering-blog.sre.gridx.de/',
                                    label: 'Engineering Blog',
                                    icon: <HugoLogoIcon />,
                                }
                                ]}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Content>
        </Page>
    );
};

